
<div [ngStyle]="mapDivStyle()">
  <div class='lgr_col'>
    <div class='lgr_79 lgo_01'><dynamic-field [id]='"messageline"' [size]=79 [(ngModel)]='messageline'></dynamic-field></div>
  </div>
</div>

